import { render, staticRenderFns } from "./TakoverWarning.vue?vue&type=template&id=fa5a1cf0"
import script from "./TakoverWarning.vue?vue&type=script&lang=js"
export * from "./TakoverWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa5a1cf0')) {
      api.createRecord('fa5a1cf0', component.options)
    } else {
      api.reload('fa5a1cf0', component.options)
    }
    module.hot.accept("./TakoverWarning.vue?vue&type=template&id=fa5a1cf0", function () {
      api.rerender('fa5a1cf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/takover-warning/TakoverWarning.vue"
export default component.exports